'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { NativeSelect, NativeSelectOption } from '@svenskaspelab/ui/react/select';
import { useRouter, useSearchParams } from 'next/navigation';
import { useState } from 'react';
const options = [
    {
        value: 'regCloseTime',
        text: 'Spelstopp',
    },
    {
        value: 'netSale',
        text: 'Omsättning',
    },
    {
        value: 'extraMoney',
        text: 'Extrapengar',
    },
];
const defaultSortBy = 'regCloseTime';
function isSortDrawByType(value) {
    if (value === null) {
        return false;
    }
    return options.some((option) => option.value === value);
}
/**
 * Select component for managing the search params when sorting draws.
 *
 * @param root0 the input props
 * @param root0.className optional className to override default styles
 * @returns A select element that changes the sortBy search parameter.
 */
export default function DrawSortingSelect({ className }) {
    const searchParams = useSearchParams();
    const router = useRouter();
    const initialSearchParams = new URLSearchParams(searchParams);
    const sortDrawsByFromUrl = initialSearchParams.get('sortDrawsBy');
    const defaultSortValue = isSortDrawByType(sortDrawsByFromUrl) ? sortDrawsByFromUrl : defaultSortBy;
    const [selectedValue, setSelectedValue] = useState(defaultSortValue);
    const handleChange = (event) => {
        const sortValue = isSortDrawByType(event.target.value) ? event.target.value : defaultSortBy;
        setSelectedValue(sortValue);
        const currentSearchParams = new URLSearchParams(searchParams);
        currentSearchParams.set('sortDrawsBy', sortValue);
        const newUrl = `${globalThis.location.pathname}?${currentSearchParams.toString()}`;
        router.replace(newUrl);
    };
    return (_jsx(NativeSelect, { className: className, "aria-invalid": false, value: selectedValue, onChange: handleChange, name: "sorting", children: options.map((option) => (_jsx(NativeSelectOption, { value: option.value, children: option.text }, option.value))) }));
}
//# sourceMappingURL=DrawSelector.SortingSelect.js.map